import {
    DEEPLINK,
    PARAMS,
    MODALS
  } from '../actions';
  
  export const setDeeplink = (payload, history) => {
    let params = ""
    if (payload) {
      if (payload.type === 0) params = "?deepLink=" + btoa(JSON.stringify(payload))
      if (payload.type === 0 || payload.type === 1) history.push(payload.module + params)
    }
    
    return (
      {
        type: DEEPLINK,
        payload: payload
      }
    )
  }

  export const setParams = (payload) => {
    return (
      {
        type: PARAMS,
        payload: payload
      }
    )
  }

  export const setModals = (payload) => {
    return (
      {
        type: MODALS,
        payload: payload
      }
    )
  }